import Icon from '../components/Icon.vue'

Icon.register({
  'graduation-cap': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M622.3 153.2L343.4 67.5C328.2 62.8 311.8 62.8 296.6 67.5L17.7 153.2C-5.9 160.4-5.9 191.6 17.7 198.8L66.3 213.7C55.6 226.9 49.1 243 48.4 260.6 38.8 266.1 32 276.1 32 288 32 298.8 37.7 307.9 45.9 313.6L20.3 428.5C18.1 438.5 25.7 448 35.9 448H92C102.3 448 109.9 438.5 107.7 428.5L82.1 313.6C90.3 307.9 96 298.8 96 288 96 276.4 89.5 266.8 80.3 261.1 81.1 246.1 88.8 232.8 101 224.4L296.6 284.5C305.7 287.3 323 290.8 343.4 284.5L622.3 198.8C645.9 191.6 645.9 160.4 622.3 153.2zM352.8 315.1C324.3 323.9 300 319 287.2 315.1L142.2 270.5 128 384C128 419.4 214 448 320 448S512 419.4 512 384L497.8 270.5 352.8 315.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/graduation-cap.js
// module id = 7mFz
// module chunks = 144